import axios from "axios";
import Cookies from "universal-cookie";

const BaseUrl = "https://s-plus.ir/api";

const base_url = axios.create({
  baseURL: BaseUrl,
});
const cookies = new Cookies();
const token = cookies.get("api_key");
console.log(token);
if (token) {
  base_url.defaults.headers["Authorization"] = token;
} else {
  base_url.defaults.headers["Authorization"] = "Guest Token";
}
base_url.defaults.headers["Content-Type"] = "application/json";
export const Signle_Call = async (apitools) => {
  const Tools = apitools;
  const Method = Tools.method;
  const Data = Tools.data;
  const Path = Tools.path;
  const Version = Tools.version || "";
  const token = cookies.get("api_key");
  const Headers = { Authorization: token };

  // all webservice REAL methods list
  const All_Real_Methods = ["get", "post", "patch", "put", "delete"];

  if (All_Real_Methods.indexOf(Method) !== -1) {
    const access_api = new Api(Method, Path, Data, Headers, Version);
    const response = await access_api.ApiCall();
    return response;
  } else {
    return {
      type: "error",
      respose: "unknown method mode",
    };
  }
};

export const Multiple_Call = async (all_api_calls) => {
  let apis = [];
  let jobs = [];
  for (let a = 0; a < all_api_calls.length; a++) {
    apis.push(all_api_calls[a].tools);
    jobs.push(all_api_calls[a].job);
  }

  let final = [];
  for (let i = 0; i < apis.length; i++) {
    const callFunction = () => {
      return new Promise((final_data) => {
        return final_data(Signle_Call(apis[i]));
      });
    };
    let api_final_object = await callFunction();
    api_final_object.job = jobs[i];
    final.push(api_final_object);
    if (final.length === apis.length) {
      return final;
    }
  }
};

class results {
  constructor() {}
  success(server_response) {
    return {
      type: 1, // means api worked currectly
      response: server_response,
    };
  }
  failed(server_response) {
    return {
      type: 0,
      response: server_response,
    };
  }
}

class Api extends results {
  constructor(METHOD, PATH, DATA, HEADERS, VERSION) {
    super();
    this.METHOD = METHOD;
    this.PATH = PATH;
    this.DATA = DATA;
    this.HEADERS = HEADERS;
    this.VERSION = VERSION;
  }
  ApiCall() {
    return new Promise((resolve) => {
      this.DATA
        ? axios[this.METHOD](
            `${BaseUrl}${this.VERSION ? "/v" + this.VERSION : ""}/${this.PATH}`,
            this.DATA,
            { headers: this.HEADERS }
          )
            .then((response) => {
              resolve(super.success(response));
            })
            .catch((error) => {
              resolve(
                super.failed(
                  error
                    ? error.response
                      ? error.response
                      : error
                    : "network error i guess"
                )
              );
            })
        : axios[this.METHOD](
            `${BaseUrl}${this.VERSION ? "/v" + this.VERSION : ""}/${this.PATH}`,
            {
              headers: this.HEADERS,
            }
          )
            .then((response) => {
              resolve(super.success(response));
            })
            .catch((error) => {
              resolve(
                super.failed(
                  error
                    ? error.response
                      ? error.response
                      : error
                    : "network error i guess"
                )
              );
            });
    });
  }
}

export { base_url };
